import { useCallback, useEffect, useState } from "react";
import useStore from "store/store";
import { adminApiService } from "../services/api";

const useDashboard = (currentPage = 1, pageSize = 10) => {
  const [totalProduct, setTotalProduct] = useState(null);
  const [totalSales, setTotalSales] = useState(null);
  const [totalUsers, setTotalUsers] = useState(null);
  const [totalNewUsers, setTotalNewUsers] = useState(null);

  const [error, setError] = useState(null);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    totalItems: 0,
    totalPages: 0,
  });
  const [totalOrders, setTotalOrders] = useState(0);
  const [data, setData] = useState(null);
  const setIsLoading = useStore((state) => state.setIsLoading);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await adminApiService.getTotalProducts();

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();

      setTotalProduct(result.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTotalSales = async () => {
    try {
      setIsLoading(true);
      const response = await adminApiService.getTotalSales("weekly");

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const res = await response.json();
      

      setTotalSales(res.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTotalSalesByPeriod = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await adminApiService.getTotalSales("monthly");
      const result = await response.json();
      setData(result);

      setTotalSales(parseFloat(result.current_period.total_amount || 0));
      setTotalOrders(result.current_period.number_of_orders || 0);
    } catch (error) {
      console.error("Failed to fetch total sales:", error);
      setData(null);
      setTotalSales(0);
      setTotalOrders(0);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTotalSalesByPeriod();
  }, [fetchTotalSalesByPeriod]);

  const fetchTotalUsers = async () => {
    try {
      setIsLoading(true);
      const response = await adminApiService.getTotalUsers();

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();

      setTotalNewUsers(result.totalNew);
      setTotalUsers(result.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAnalyticsData = async () => {
    try {
      const response = await adminApiService.getAnalytics(currentPage, pageSize);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setAnalyticsData(data.data);
      setPagination({
        currentPage: data.currentPage,
        pageSize: data.pageSize,
        totalItems: data.totalItems,
        totalPages: data.totalPages,
      });
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchData();
    fetchTotalSales();
    fetchTotalUsers();
  }, []);

  useEffect(() => {
    fetchAnalyticsData();
  }, [currentPage, pageSize]);

  return {
    totalProduct,
    totalSales,
    error,
    totalUsers,
    totalNewUsers,
    analyticsData,
    pagination,
    totalOrders,
  };
};

export default useDashboard;
